<template>
  <div id="star">
    <div class="container">
      <div class="star-info">
        <div class="left-box" @click="switchStar('prev')">
          <div class="btn"></div>
        </div>
        <div class="info-box">
          <div class="bg">
            <div class="title-1"></div>
            <div class="title-2"></div>
          </div>
          <div class="basic">
            <div class="title">
              <span>{{ subStar.memberName || "-" }}</span>
              <div class="tap-btn">
                <a :href="subStar.tapLink" target="_blank" @click="clickTap"></a>
              </div>
            </div>
            <div class="des a" v-html="formatDes(subStar.memberDesc)"></div>
            <div class="fans">
              <div class="icon"></div>
              粉丝数 <span>{{ subStar.fans || "-" }}</span>
            </div>
            <div class="split-line"></div>
            <div
              class="video-btn"
              :class="{ hide: !subStar.videoId }"
              :style="{ 'background-image': `url(${subStar.cover})` }"
              @click="playVideo(subStar.videoId)"
            >
              <div class="play-btn"></div>
            </div>
          </div>
          <div class="star-box">
            <div
              class="star"
              :style="{ 'background-image': `url(${subStar.starAvatar})` }"
            ></div>
            <div
              class="shadow"
              :style="{ 'background-image': `url(${subStar.starAvatar})` }"
            ></div>
          </div>
          <div class="match">
            <div class="team">
              <div class="icon">
                <div
                  class="head"
                  :style="{ 'background-image': `url(${subStar.teamAvatar})` }"
                ></div>
              </div>
              <span>{{ subStar.teamName || "-" }}</span>
            </div>
            <div class="split-line"></div>
            <div class="base-data" ref="baseData"></div>
          </div>
        </div>
        <div class="right-box" @click="switchStar('next')">
          <div class="btn"></div>
        </div>
      </div>
      <div class="star-list">
        <ul class="inner" :style="{ width: `${17.14976 * starList.length}vh` }">
          <li
            v-for="(star, key) in starList"
            :key="key"
            :class="{ active: star.memberCode == subStar.memberCode }"
            @click="switchStar('list', star, key)"
          >
            <div
              class="thumb"
              :style="{ 'background-image': `url(${star.avatarThumbnail})` }"
            ></div>
          </li>
        </ul>
      </div>
    </div>
    <star-video ref="starVidoe"></star-video>
  </div>
</template>

<script>
import * as api from "@/service/index";
import * as echarts from "echarts";
import anime from "animejs";
import { mapState } from "vuex";
import { getOption, updataOption } from "@/utils/initEcharts";
import StarVideo from "./video.vue";

export default {
  components: { StarVideo },
  data() {
    return {
      animition: null,
      subKey: 0,
      subStar: {},
      starList: [],

      option: {},
      myChart: null,
      inAnimition: false,
      tempTime: 0,
      subSeasonID: ''
    };
  },
  computed: {
    ...mapState(["token", "seasonInfo"]),
  },
  watch: {
    seasonInfo: {
      handler(newVal) {
        if(newVal && newVal.id) {
          this.subSeasonID = newVal.id;
          // this.getStarList();
        }
      },
      immediate: true,
      deep: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initEcharts();
      this.initAnime();
    });
  },
  methods: {
    async getStarList() {
      if(!this.token) return;
      const res = await api.reqStarList({
        token: this.token,
        seasonId: this.subSeasonID
      });

      if (res.status == 200) {
        this.starList = this.$lg(res, "data", []);

        if (this.starList.length == 0) return;
        this.$nextTick(() => {
          this.switchStar('list', this.starList[0], 0);
        })
      }
    },
    initEcharts() {
      let chartDom = this.$refs.baseData;
      this.myChart = echarts.init(chartDom);
      this.option = getOption(chartDom, 'member');
      this.option && this.myChart.setOption(this.option);
      chartDom.childNodes[0].style.position = "absolute";
    },
    updataEcharts(subSeason) {
      this.option = updataOption(subSeason, this.option, "star");
      this.option && this.myChart.setOption(this.option);
    },
    switchStar(type, info, key) {
      let newTime = new Date().getTime();
      if(newTime - this.tempTime >= 1 * 2000) {
        this.tempTime = newTime
      }else {
        return;
      }
      
      if(type == 'list') {
        this.subStar = info;
        this.subKey = key;
      }else if(type == 'prev') {
        if (this.subKey <= 0) {
          this.subKey = this.starList.length - 1;
        } else {
          this.subKey -= 1;
        }
        this.subStar = this.starList[this.subKey];
      }else if(type == 'next') {
        if (this.subKey >= this.starList.length - 1) {
          this.subKey = 0;
        } else {
          this.subKey += 1;
        }
        this.subStar = this.starList[this.subKey];
      }

      this.animition.restart();
      // 获取该明星选手的战斗数据
      if(!this.token) return;
      let data = {
        token: this.token,
        memberCode: this.subStar.memberCode,
        // seasonId: this.subSeasonID
        seasonId: 15
      };
      api.reqStarInfo(data).then((res) => {
        if (res.status == 200) {
          this.updataEcharts(res.data);
        }
      });

      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('点击选手信息', {
        '#star_id': this.subStar.memberName
      });
    },
    playVideo(vid) {
      this.$refs.starVidoe.play(vid);
    },
    formatDes(str) {
      return str?.replace(/\\n/g, '\n') || '-';
    },
    clickTap() {
      // 埋点
      if(typeof tapdb == 'undefined') return;
      tapdb.trackEvent('点击选手TapTap按钮', {
        '#star_id': this.subStar.memberName
      });
    },
    initAnime() {
      this.animition = anime.timeline({
        easing: "easeOutExpo",
        autoplay: false,
      });
      this.animition.add(
        {
          targets: ".star-box",
          translateX: [100, 0],
          opacity: [0, 1],
          duration: 1500,
        },
        0
      );
      this.animition.add(
        {
          targets: ".star-box .shadow",
          translateX: [-40, 0],
          scale: [1, 1.12],
          opacity: [0, 0.1],
          duration: 1500,
        },
        200
      );
      this.animition.add(
        {
          targets: ".basic .title",
          translateX: [40, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        500
      );
      this.animition.add(
        {
          targets: ".basic .title .tap-btn",
          translateX: [-100, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        500
      );
      this.animition.add(
        {
          targets: ".basic .des",
          translateX: [60, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        600
      );
      this.animition.add(
        {
          targets: ".basic .fans",
          translateX: [60, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        700
      );
      this.animition.add(
        {
          targets: ".basic .split-line",
          translateX: [60, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        700
      );
      this.animition.add(
        {
          targets: ".basic .video-btn",
          translateX: [60, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        800
      );
      this.animition.add(
        {
          targets: ".match .team",
          translateX: [-40, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        500
      );
      this.animition.add(
        {
          targets: ".match .base-data",
          translateX: [-40, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        600
      );
      this.animition.add(
        {
          targets: ".bg .title-1",
          translateX: [-150, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        200
      );
      this.animition.add(
        {
          targets: ".bg .title-2",
          translateX: [150, 0],
          opacity: [0, 1],
          duration: 1000,
        },
        300
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/star/index";
</style>